// extracted by mini-css-extract-plugin
export default {"loaderBody":"style_loaderBody__g7a+O","loader":"style_loader__qvlW1"};